import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuillEditorComponent } from 'ngx-quill';
import { ToastrService } from 'ngx-toastr';
import { AddExternalMediaComponent } from 'src/app/class/add-external-media/add-external-media.component';
import { Settings } from 'src/app/models/settings.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';
import { moduledetails, modulemedia } from '../..//models/module/moduledetails'
import * as introJs from 'intro.js/intro.js';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';

declare const $: any;


@Component({
  selector: 'app-moduleeditor',
  templateUrl: './moduleeditor.component.html',
  styleUrls: ['./moduleeditor.component.css']
})
export class ModuleeditorComponent implements OnInit, OnDestroy {
  id: number;
  destroyed: boolean;
  module: moduledetails = new moduledetails();
  accessDaysChanged = false;
  updateExsitingStudentsAccessDays: boolean = false;
  @ViewChild('addExternalMediaComponent') addExternalMediaComponent: AddExternalMediaComponent;
  @ViewChild('mediaModal') mediaModal: ElementRef;
  @ViewChild('externalMediaModal') externalMediaModal: ElementRef;
  @ViewChild('confirmUpdateExistingStudents') confirmUpdateExistingStudents: ElementRef;
  @ViewChild('description') editor: QuillEditorComponent;
  @ViewChild('price') priceControl: ElementRef;
  logofilelist: FileList;

  @ViewChild('logoimg') logoimg: ElementRef
  quill: any = {};

  logChange($event) {
    console.log(this.editor);
    console.log($event);
  }
  moduleid: any;
  schoolid: any;
  introJS = introJs();
  toursteps: any[] = [];
  constructor(public headerinfo: ComponentheaderService, private router: Router, private activatedroute: ActivatedRoute, public modulemanager: ModulemanagementService, 
    private schoolmanager: SchoolmanagementService, private toastr: ToastrService, public settings: Settings, private utilservice: UtilService) {
    this.headerinfo.setHeaderDisplay(
      'Loading Course...',
      [],
      []);
    this.toursteps = [

      {

        intro: "Enter Course Details",
        position: 'right'
      },
    ];

    this.introJS.setOptions({
      steps: this.toursteps,
      showProgress: false,
      exitOnOverlayClick: true,
      exitOnEsc: true,
      skipLabel: 'Exit',
    });

  }

  confirmAccessDaysShouldBeUpdatedForExisting() {
    $(this.confirmUpdateExistingStudents.nativeElement).modal('show');
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
  ngAfterViewInit(): void {
    //debugger;++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const mythis = this;
    this.editor.onEditorCreated.subscribe(() => {
      this.quill = this.editor.quillEditor;
    });
    this.editor.onEditorChanged.subscribe(() => {
      this.quill = this.editor.quillEditor;
    });
  }
  async ngOnInit() {
    this.moduleid = this.activatedroute.snapshot.queryParams.moduleID;

    this.schoolid = await this.schoolmanager.getSchoolIdFromSubdomain().toPromise();

    //debugger;
    //const adminAction = { displaytext: 'Add Video from Youtube/Vimeo', callback: this.addFromYoutube.bind(this), classes: ['fab', 'fa-youtube'] };

    if (this.moduleid) {
      const data: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
      this.module = data.moduleinfo;

      if (this.module.logo) {
        this.logoimg.nativeElement.style.display = 'initial';
      }

      //debugger;
      if (this.module.description) {
        const setQuillDataFunction = () => {
          if (this.quill && this.quill.root) {
            this.quill.root.innerHTML = this.module.description;
          }
          else {
            if (!this.destroyed) {
              setTimeout(setQuillDataFunction, 100);
            }
          }
        };
        setQuillDataFunction();
      }
      let displayName = this.module.name;
      if (this.module.courseCode) {
        displayName += ` (${this.module.courseCode})`;
      }
      this.headerinfo.setHeaderDisplay(
        'Edit Course',
        [

          { displaytext: "School", route: `/user/schoolhome` },
          { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: this.module.id } },
          { displaytext: 'Edit Course', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
        ],
        [ { displaytext: 'Insert From Media Library', callback: this.insertFromMediaLibrary.bind(this), classes: ['fas', 'fa-photo-video'], disabled: !await this.utilservice.hasFeature(FeatureGroups.MEDIA_LIBRARY), featureGroup: FeatureGroups.MEDIA_LIBRARY },
        {displaytext: 'Add Video from Youtube/Vimeo', callback: this.addFromYoutube.bind(this), classes: ['fab', 'fa-youtube'], disabled: !await this.utilservice.hasFeature(FeatureGroups.YOUTUBE_VIMEO_VIDEOS), featureGroup: FeatureGroups.YOUTUBE_VIMEO_VIDEOS }
      ],
        this.toursteps);
    }
    else {
      // const schooldetails: any = await this.schoolmanager.getSchoolDetails(this.schoolid).toPromise();
      this.module = new moduledetails();
      this.module.id = 0;
      this.module.schoolID = this.schoolid;
      this.headerinfo.setHeaderDisplay(
        'New Course',
        [
          { displaytext: 'Home', route: '/' },
          // { displaytext: schooldetails.schoolInfo.schoolName, route: `/user/schoolhome`, params: { schoolID: this.schoolid } },
          { displaytext: 'School', route: `/user/schoolhome` },
          { displaytext: 'New Course', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
        ],
        [{displaytext: 'Add Video from Youtube/Vimeo', callback: this.addFromYoutube.bind(this), classes: ['fab', 'fa-youtube'], disabled: !await this.utilservice.hasFeature(FeatureGroups.YOUTUBE_VIMEO_VIDEOS), featureGroup: FeatureGroups.YOUTUBE_VIMEO_VIDEOS }
        ], 
        this.toursteps);
    }
    this.introJS.moduleid = this.module.id;
    this.introJS.oncomplete(function (this) {
      window.location.href = `/user/moduledetails?moduleID=${this.moduleid}`;
    });
    //this.introJS.start();
  }
  
  async createupdatemodule() {
    //debugger;
    // if (this.logofilelist && this.logofilelist.length > 0 && !this.handleLogoImageLoaded()) {
    //   return;
    // }
    //debugger;
    this.module.description = this.quill.root.innerHTML;

    if (this.module.description.length > 65535) {
      this.toastr.error('Description too long');
      return;
    }
    
    if(parseFloat(this.priceControl.nativeElement.value) > 0 && !await this.utilservice.hasFeature(FeatureGroups.E_COMMERCE)){
      this.toastr.error(`The e-commerce feature is required to charge for courses. Please upgrade your account to use charge for courses`);
      return;
    }

    const data: any = await this.modulemanager.createModule(this.module).toPromise();
    const moduleid = data.moduleid;
    if (this.accessDaysChanged && this.module.id != 0) {
      //debugger;
      const confirmret = await this.utilservice.confirm('Update Current Students', 'Do you want to update the access days of current students?')
      //debugger;
      if (confirmret) {
        await this.modulemanager.setModuleStudentsAccessDays(this.module.id, this.module.accessdays).toPromise();
      }
    }
    if (this.logofilelist && this.logofilelist.length > 0) {
      await this.modulemanager.uploadModuleLogo(moduleid, this.logofilelist[0]).toPromise();
    }
    this.toastr.success('Course saved');
    this.router.navigate(['/user/moduledetails'], { queryParams: { moduleID: moduleid } });//.then(()=>{window.location.reload(true)});
    
  }

  handleLogoFileChange(files: FileList) {
    if (files.length > 0) {
      this.logofilelist = files;
      this.logoimg.nativeElement.src = URL.createObjectURL(files[0]);
      this.logoimg.nativeElement.style.display = 'initial';
      return;
    }

    if (this.module.logo) {
      this.logoimg.nativeElement.src = this.module.logo;
    } else {
      this.logoimg.nativeElement.style.display = 'none';
    }
  }

  // handleLogoImageLoaded(): boolean {
  //   //debugger;
  //   const sizevalid: boolean = this.validateModuleImage();

  //   if (!sizevalid) {
  //     this.toastr.error(`The image supplied is the wrong size. Image dimensions must be ${this.settings.moduleImageWidth} x ${this.settings.moduleImageHeight}`);
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }

  validateModuleImage(): boolean {
    const img = this.logoimg.nativeElement;

    let imageWidth = img.naturalWidth;
    let imageHeight = img.naturalHeight;

    if (Math.abs(imageWidth - this.settings.moduleImageWidth) > 2 || Math.abs(imageHeight - this.settings.moduleImageHeight) > 2) {//this gives an error margin of 2px
      return false;
    }
    else {
      return true;
    }
  }

  insertFromMediaLibrary(){
    $(this.mediaModal.nativeElement).modal('show');
  }

  addFromYoutube() {
    $(this.externalMediaModal.nativeElement).modal('show');
  }

  closeExternalMediaModal() {
    this.addExternalMediaComponent.clear();
    $(this.externalMediaModal.nativeElement).modal('hide');
  }


  externalMediaSelected() {
    const mediaurl = this.addExternalMediaComponent.iframeurl;
    if (mediaurl) {
      this.insertMediaUrl(mediaurl);
      this.addExternalMediaComponent.clear();
      $(this.externalMediaModal.nativeElement).modal('hide');
    }
  }
  insertMediaUrl(playerurl) {
    const range = this.quill.getSelection();
    let index = 0;

    if (range !== null) {
      index = range.index;
    } else {
      index = this.quill.root.innerHTML.length - 1;
      //this.quill.container.innerHTML += "<p></p>";
    }
    //debugger;
    //this.quill.insertEmbed(index, 'media', media.playerurl);

    this.quill.insertEmbed(index, 'media', playerurl);
    //const playerurl = `${location.protocol}//${location.hostname}:${location.port}${media.playerurl}`;
    //this.quill.root.innerHTML += `<iframe src="${playerurl}" class="mediaiframe"></iframe>`;
    this.quill.root.innerHTML += "<p></p>";
  }

  mediaSelected(media: modulemedia){
    const playerurl = `${media.playerurl}`;    
    this.insertMediaUrl(playerurl);

    $(this.mediaModal.nativeElement).modal('hide');
  }
}
